import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
// import { useEffect } from 'react';
import { useState, useEffect } from 'react';
// import AutoCompleteAddress from '../../../../../../_metronic/helpers/components/AutoCompletePlace';
import AutoCompleteAddress2 from '../../../../../../_metronic/helpers/components/AutoCompletePlace/index2';
import { useFormik } from 'formik';
import { useAuth } from '../../../../auth';
import CountryDropDown2 from '../../../../../../_metronic/helpers/countryDropDown2';
import { successToast } from '../../../../../../_metronic/helpers/components/Toaster';


interface QuantityOption {
    batchId?: string | null;
    orderId?: string;
    categoryId?: string;
    categoryName?: string;
    itemId?: string;
    itemName?: string;
    quantity?: number;
}


interface SustainabilityFormProps {
    onClose: () => void
}
interface PersonalDetails {
    name: string;
    // add other personal details properties as needed
}

interface ProductType {
    id?: string;
    _id?: string;
    name?: string;
    title?: string;
    categoryName?: string;
    // add other properties as you discover them
}

interface RawMaterialType {
    id?: string;
    _id?: string;
    name?: string;
    title?: string;
    itemName?: string;
    // add other properties as needed
}

interface Recipient {
    id?: string;
    _id?: string;
    name?: string;
    userName?: string;
    personalDetails: PersonalDetails;
    address?: {
        latitute: number;
        longitute: number;
        street: string;
        country: string;
        city: string;
        zipCode: string;
        state: string;
    };
    // add other properties as needed
}

interface FormValues {
    uniqueNumber: string
    dateOfIssuance: string
    supplierName: string
    supplierAddress: string
    certificationSystem: string
    certificateNumber: string
    recipientName: string
    recipientAddress: string
    contractNumber: string
    dispatchAddress: string
    sameAsSupplierAddress: boolean
    receiptAddress: string
    sameAsRecipientAddress: boolean
    dateOfDispatch: string
    typeOfProduct: string
    typeOfRawMaterial: string
    countryOfOrigin: string
    country: string
    quantity: string
    quantityUnit: string
    isccCompliant: string
    euRedCompliant: string
    chainOfCustody: string
    // rawMaterialComplies: string
    // agriculturalBiomass: string
    // agriculturalBiomassLowILUC: string
    // wasteOrResidue: string
    // wasteSpecification: string
    // fuelProductionSupport: string
    // supportSpecification: string
    totalDefaultValue: string
    eec: string
    el: string
    ep: string
    etd: string
    eu: string
    esca: string
    eccs: string
    eccr: string
    shipKm: string
    trainKm: string
    roadKm: string
    oilExtractionDefault: string,
    soilN2ODefault: string,
    escaSpecification: string
    nuts2Area: string
    degradedLandBonus: string
    foodSecurityStandard: string,
    euDeforestationRegulation: string,
    nonGMOFood: string,
    nonGMOTechnical: string,
    wasteSpecification: string
    supportSpecification: string
    rawMaterialComplies: string
    agriculturalBiomass: string
    agriculturalBiomassLowILUC: string
    wasteOrResidue: string
    fuelProductionSupport: string
}

const validationSchema = Yup.object({
    uniqueNumber: Yup.string().required('Required'),
    dateOfIssuance: Yup.string().required('Required'),
    supplierName: Yup.string().required('Required'),
    recipientName: Yup.string().required('Required'),
    typeOfProduct: Yup.string().required('Required'),
    quantity: Yup.string().required('Required'),
})

const SustainabilityDeclarationForm: React.FC<SustainabilityFormProps> = ({ onClose }) => {

    const [uniqueNumber, setUniqueNumber] = useState<string>('');
    useEffect(() => {
        const timestamp = Date.now();
        setUniqueNumber(timestamp.toString());
    }, []);
    const { currentUser } = useAuth()

    const [selectedOrderIds, setSelectedOrderIds] = useState<string[]>([]);

    const [recipientOptions, setRecipientOptions] = useState<Recipient[]>([]);
    const [loading, setLoading] = useState(false);
    const [dispatchAddress, setDispatchAddress] = useState('');
    const [dispatchLocation, setDispatchLocation] = useState<any>({});
    const [receiptAddress, setReceiptAddress] = useState('');
    const [receiptLocation, setReceiptLocation] = useState<any>({});


    // 2. Inside your component, declare the states with proper types:
    const [productTypes, setProductTypes] = useState<ProductType[]>([]);
    const [rawMaterialTypes, setRawMaterialTypes] = useState<RawMaterialType[]>([]);
    const [selectedProductType, setSelectedProductType] = useState<string>('');

    const [submitLoading, setSubmitLoading] = useState(false);

    const [quantityOptions, setQuantityOptions] = useState<QuantityOption[]>([]);
    const [selectedQuantities, setSelectedQuantities] = useState<string[]>([]);
    const [isQuantityDropdownOpen, setIsQuantityDropdownOpen] = useState(false);



    const [isNoSelected, setIsNoSelected] = useState(false);
    const [orderDetails, setOrderDetails] = useState<any>(null);

    const fetchOrderDetails = async (orderId: string, setFieldValue?: (field: string, value: any) => void) => {
        if (!orderId) return;

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_API_URL}return/orders/${orderId}`,
                {
                    headers: getAuthHeaders()
                }
            );

            const orderData = response.data?.data?.[0];
            setOrderDetails(orderData);
            console.log('Order details:', orderData);

            // Add these debug logs
            console.log('setFieldValue available:', !!setFieldValue);
            console.log('orderData?.isccEu:', orderData?.isccEu);
            console.log('Full isccEu object:', JSON.stringify(orderData?.isccEu, null, 2));

            // Prefill the greenhouse gas emission fields if ISCC EU data exists
            if (orderData?.isccEu && setFieldValue) {
                const isccData = orderData.isccEu;

                console.log('ISCC Data found:', isccData);

                // Calculate ETD as sum of etdCollect + etdReturn
                const etdCollectValue = isccData.etdCollect?.value || 0;
                const etdReturnValue = isccData.etdReturn?.value || 0;
                const etdSum = etdCollectValue + etdReturnValue;

                // Extract road distance from routeLength
                const routeLength = orderData.routeLength || '';
                const roadKmValue = routeLength.replace(/[^\d.]/g, ''); // Extract numeric value (removes "km" and spaces)

                console.log('Route length mapping:', {
                    original: routeLength,
                    extracted: roadKmValue
                });

                console.log('ETD calculation:', {
                    etdCollect: etdCollectValue,
                    etdReturn: etdReturnValue,
                    sum: etdSum
                });

                // Map the API response to form fields
                setFieldValue('eec', isccData.eec?.value?.toString() || '');
                setFieldValue('el', isccData.el?.value?.toString() || '');
                setFieldValue('esca', isccData.esca?.value?.toString() || '');
                setFieldValue('etd', etdSum.toString()); // Use the calculated sum

                // Map road distance
                setFieldValue('roadKm', roadKmValue); // ✅ Map routeLength to roadKm

                // For fields not in the response, you can set defaults or leave empty
                setFieldValue('ep', ''); // Not in response
                setFieldValue('eu', ''); // Not in response  
                setFieldValue('eccs', ''); // Not in response
                setFieldValue('eccr', ''); // Not in response
                setFieldValue('shipKm', ''); // Not in response
                setFieldValue('trainKm', ''); // Not in response

                console.log('Successfully set field values with ETD sum:', etdSum, 'and roadKm:', roadKmValue);

            } else {
                console.log('Debug info:');
                console.log('- orderData exists:', !!orderData);
                console.log('- orderData.isccEu exists:', !!orderData?.isccEu);
                console.log('- setFieldValue exists:', !!setFieldValue);
                console.log('No ISCC data found or setFieldValue not available');
            }

        } catch (error) {
            console.error('Error fetching order details:', error);
            setOrderDetails(null);
        }
    };


    const fetchQuantities = async (toPickupPointId: string) => {
        if (!toPickupPointId) return;

        try {
            const authData = localStorage.getItem('kt-auth-react-v');
            const pickuppointid = authData ? JSON.parse(authData).data.pickuppointid : '';

            const response = await axios.get(
                `${process.env.REACT_APP_BASE_API_URL}returnQuantity?fromPickupPointId=${pickuppointid}&toPickupPointId=${toPickupPointId}`,
                {
                    headers: getAuthHeaders()
                }
            );

            const quantities = response.data?.data || [];
            setQuantityOptions(quantities);
        } catch (error) {
            console.error('Error fetching quantities:', error);
            setQuantityOptions([]);
        }
    };



    // Helper function to get auth headers
    const getAuthHeaders = () => {
        const authData = localStorage.getItem('kt-auth-react-v');
        let token = '';
        let franchiseeid = '';

        if (authData) {
            const parsedData = JSON.parse(authData);
            token = parsedData?.data?.token || '';
            franchiseeid = parsedData?.data?.franchiseeid || '';
        }

        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'franchiseeid': franchiseeid,
        };
    };

    // Fetch product types
    useEffect(() => {
        const fetchProductTypes = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}clients/101212/categories?page=0&size=10`, {
                    method: 'GET',
                    headers: getAuthHeaders()
                });

                const data = await response.json();
                console.log('API Response:', data);

                if (data && Array.isArray(data)) {
                    setProductTypes(data);
                } else if (data && data.content && Array.isArray(data.content)) {
                    setProductTypes(data.content);
                } else if (data && data.data && Array.isArray(data.data)) {
                    setProductTypes(data.data);
                } else {
                    console.error('Unexpected response structure:', data);
                    setProductTypes([]);
                }
            } catch (error) {
                console.error('Error fetching product types:', error);
                setProductTypes([]);
            }
        };

        fetchProductTypes();
    }, []);

    // Fetch raw material types when product type is selected
    useEffect(() => {
        if (selectedProductType) {
            const fetchRawMaterialTypes = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}categories/${selectedProductType}/items?page=0&size=10`, {
                        method: 'GET',
                        headers: getAuthHeaders()
                    });

                    const data = await response.json();
                    console.log('Raw materials response:', data);

                    if (data && Array.isArray(data)) {
                        setRawMaterialTypes(data);
                    } else if (data && data.content && Array.isArray(data.content)) {
                        setRawMaterialTypes(data.content);
                    } else if (data && data.data && Array.isArray(data.data)) {
                        setRawMaterialTypes(data.data);
                    } else {
                        setRawMaterialTypes([]);
                    }
                } catch (error) {
                    console.error('Error fetching raw material types:', error);
                    setRawMaterialTypes([]);
                }
            };

            fetchRawMaterialTypes();
        }
    }, [selectedProductType]);

    const getSupplierNameFromStorage = () => {
        try {
            const authData = localStorage.getItem('kt-auth-react-v');
            if (authData) {
                const parsedData = JSON.parse(authData);
                return parsedData?.data?.pickuppointName || '';
            }
        } catch (error) {
            console.error('Error parsing localStorage data:', error);
        }
        return '';
    };


    const formik = useFormik({
        initialValues: {
            // Add your form fields here
            recipient: '',
            // ... other fields
        },
        onSubmit: (values) => {
            // Handle form submission
            console.log(values);
        }
    });


    const fetchRecipients = async () => {
        setLoading(true);
        try {
            const authData = localStorage.getItem('kt-auth-react-v');
            const token = authData ? JSON.parse(authData).data.token : '';

            const response = await axios.get(
                `${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=PICKUP_POINT`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );

            // Assuming the API returns an array of users with name property
            const recipients = response.data.content || response.data || [];
            setRecipientOptions(recipients);
        } catch (error) {
            console.error('Error fetching recipients:', error);
        } finally {
            setLoading(false);
        }
    };

    // Add useEffect to fetch data when component mounts
    useEffect(() => {
        fetchRecipients();
    }, []);


    const initialValues: FormValues = {
        uniqueNumber: uniqueNumber,
        dateOfIssuance: '',
        supplierName: getSupplierNameFromStorage(),
        supplierAddress: '',
        certificationSystem: 'Please select',
        certificateNumber: '',
        recipientName: '',
        recipientAddress: '',
        contractNumber: '',
        dispatchAddress: '',
        sameAsSupplierAddress: false,
        receiptAddress: '',
        sameAsRecipientAddress: false,
        dateOfDispatch: '',
        typeOfProduct: '',
        typeOfRawMaterial: '',
        countryOfOrigin: '',
        country: '',
        quantity: '',
        quantityUnit: 'metric tons',
        isccCompliant: '',
        euRedCompliant: '',
        chainOfCustody: 'Mass balance',
        rawMaterialComplies: '',
        agriculturalBiomass: '',
        agriculturalBiomassLowILUC: '',
        wasteOrResidue: '',
        wasteSpecification: '',
        fuelProductionSupport: '',
        supportSpecification: '',
        totalDefaultValue: '',
        eec: '',
        el: '',
        ep: '',
        etd: '',
        eu: '',
        esca: '',
        eccs: '',
        eccr: '',
        shipKm: '',
        trainKm: '',
        roadKm: '',

        // ✅ Set default values for greenhouse gas section radio buttons
        oilExtractionDefault: 'No',
        soilN2ODefault: 'No',
        degradedLandBonus: 'No',

        escaSpecification: '',
        nuts2Area: '',

        // ✅ Set default values for Voluntary Add-Ons radio buttons
        foodSecurityStandard: 'No',
        euDeforestationRegulation: 'No',
        nonGMOFood: 'No',
        nonGMOTechnical: 'No',
    }


    const handleSubmit = async (values: FormValues) => {


        console.log('handleSubmit called!'); // Add this as first line
        alert('Form submission started!'); // Add this too

        setSubmitLoading(true); // Add this line
        try {
            console.log('Form values:', values); // Debug line

            const payload = {
                franchiseId: "",
                uniqueNo: values.uniqueNumber,
                date: values.dateOfIssuance,
                supplierInfo: {
                    id: "",
                    name: values.supplierName,
                    address: {
                        city: dispatchLocation?.city || "",
                        state: dispatchLocation?.state || "",
                        country: dispatchLocation?.country || "",
                        zipCode: dispatchLocation?.zipCode || "",
                        street: values.supplierAddress,
                        latitute: dispatchLocation?.lat || 0,
                        longitute: dispatchLocation?.lng || 0
                    }
                },
                recipientInfo: {
                    id: "",
                    name: values.recipientName,
                    address: {
                        city: receiptLocation?.city || "",
                        state: receiptLocation?.state || "",
                        country: receiptLocation?.country || "",
                        zipCode: receiptLocation?.zipCode || "",
                        street: values.recipientAddress,
                        latitute: receiptLocation?.lat || 0,
                        longitute: receiptLocation?.lng || 0
                    }
                },
                certificateNo: values.certificateNumber,
                contactNo: values.contractNumber,
                addressOfShippingPoint: {
                    city: dispatchLocation?.city || "",
                    state: dispatchLocation?.state || "",
                    country: dispatchLocation?.country || "",
                    zipCode: dispatchLocation?.zipCode || "",
                    street: dispatchAddress,
                    latitute: dispatchLocation?.lat || 0,
                    longitute: dispatchLocation?.lng || 0
                },
                addressOfReceivingPoint: {
                    city: receiptLocation?.city || "",
                    state: receiptLocation?.state || "",
                    country: receiptLocation?.country || "",
                    zipCode: receiptLocation?.zipCode || "",
                    street: receiptAddress,
                    latitute: receiptLocation?.lat || 0,
                    longitute: receiptLocation?.lng || 0
                },
                dateOfDispatch: values.dateOfDispatch,
                productName: values.typeOfProduct,
                countryOfOrigin: values.countryOfOrigin,
                quantity: Number(values.quantity),
                unit: values.quantityUnit === 'metric tons' ? 'METRIC_TONS' : values.quantityUnit === 'm³' ? 'M3' : 'KG',
                isISCCCompliant: values.isccCompliant === 'Yes',
                isEUREDCompliant: values.euRedCompliant === 'Yes',
                chainOfCustody: values.chainOfCustody,
                SCOPE: {
                    REDIII: (document.querySelector('[name="rawMaterialComplies"]:checked') as HTMLInputElement)?.value || '',
                    INTERMEDIATE_CROP: (document.querySelector('[name="agriculturalBiomass"]:checked') as HTMLInputElement)?.value || '',
                    ILUC: (document.querySelector('[name="agriculturalBiomassLowILUC"]:checked') as HTMLInputElement)?.value || '',
                    WASTE: (document.querySelector('[name="wasteOrResidue"]:checked') as HTMLInputElement)?.value || '',
                    PRODUCTION_SUPPORT: (document.querySelector('[name="fuelProductionSupport"]:checked') as HTMLInputElement)?.value || '',
                    WASTE_PERMIT_NUMBER: (document.querySelector('[name="wasteSpecification"]') as HTMLInputElement)?.value || '',
                    SUPPORT_SCHEME: (document.querySelector('[name="supportSpecification"]') as HTMLInputElement)?.value || ''
                }
            };

            console.log('Payload:', payload); // Debug line

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}isccSustainability/create`, // Fixed URL
                payload,
                {
                    headers: getAuthHeaders()
                }
            );

            console.log('Form submitted successfully:', response.data);
            alert('Sustainability Declaration submitted successfully!');
            onClose();
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Error submitting form. Please try again.');
        } finally {
            setSubmitLoading(false); // Add this line
        }
    };




    const inputStyle = {
        width: '100%',
        padding: '8px',
        border: '1px solid #000',
        fontSize: '12px',
        fontFamily: 'Arial, sans-serif'
    }



    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Element;
            if (!target.closest('[data-quantity-dropdown]')) {
                setIsQuantityDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const labelStyle = {
        fontSize: '12px',
        fontFamily: 'Arial, sans-serif',
        marginBottom: '4px',
        display: 'block'
    }

    const sectionHeaderStyle = {
        backgroundColor: '#005faf',
        color: 'white',
        padding: '8px',
        fontSize: '14px',
        fontWeight: 'bold',
        margin: '0',
        fontFamily: 'Arial, sans-serif'
    }




    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', border: '2px solid #000', fontFamily: 'Arial, sans-serif' }}>
            {/* Header */}
            <div style={{ backgroundColor: '#005faf', color: 'white', padding: '12px', textAlign: 'left' }}>
                <h2 style={{ margin: '0', fontSize: '16px', fontWeight: 'bold', color: 'white' }}>
                    Sustainability Declaration for Raw Materials and Intermediate Products
                </h2>
                <div style={{ fontSize: '16px', marginTop: '4px', color: "#bfbfbf", fontWeight: 'bold' }}>
                    Applies under the revised Renewable Energy Directive (EU) 2018/2001 (RED III)
                </div>
                <div style={{ position: 'absolute', right: '20px', top: '10px', fontSize: '12px' }}>
                    V4.0
                </div>
            </div>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >

                {({ values, setFieldValue }) => (
                    <Form>
                        {/* Top Section */}
                        <div style={{ padding: '12px', backgroundColor: '' }}>
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr auto',
                                    gap: '20px',
                                    marginBottom: '20px',
                                    alignItems: 'flex-start',
                                }}
                            >
                                {/* Left column: label-input pairs in rows */}
                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start' }}>
                                    {/* Row 1: Unique Number */}
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>
                                        Unique Number of Sustainability <br /> Declaration:
                                    </label>
                                    {/* <Field name="uniqueNumber" style={{ ...inputStyle, width: '350px' }} /> */}
                                    <Field
                                        name="uniqueNumber"
                                        value={uniqueNumber}
                                        disabled={true}
                                        style={{ ...inputStyle, width: '350px', backgroundColor: '#f5f5f5' }}
                                    />

                                    {/* Row 2: Date of Issuance */}
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>
                                        Date of Issuance of Sustainability <br /> Declaration:
                                    </label>
                                    <Field name="dateOfIssuance" type="date" style={{ ...inputStyle, width: '350px' }} />
                                </div>
                                {/* Right column: ISCC image */}
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <img
                                            src="/iscc.jpg"
                                            alt="ISCC Logo"
                                            style={{ maxHeight: '100px', objectFit: 'contain' }}
                                        />
                                        <a
                                            href="https://www.iscc-system.org"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#005faf',
                                                fontSize: '14px',
                                                marginTop: '2px',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            www.iscc-system.org
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Supplier and Recipient Section */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: "-10px" }}>
                            {/* Supplier */}
                            <div style={{ borderRight: '1px solid #000' }}>
                                <h3 style={sectionHeaderStyle}>Supplier</h3>
                                <div style={{ padding: '12px' }}>
                                    <div style={{ marginBottom: '12px' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Name:</label>
                                        <Field name="supplierName" style={inputStyle} />
                                    </div>
                                    <div style={{ marginBottom: '12px' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Address:</label>
                                        <Field name="supplierAddress" as="textarea" rows={3} style={inputStyle} />
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                            <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Certification System:</label>
                                            <Field name="certificationSystem" as="select" style={inputStyle}>
                                                <option>Please select</option>
                                                <option>ISCC EU</option>
                                                <option>ISCC PLUS</option>
                                            </Field>
                                        </div>
                                        <div>
                                            <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Certificate Number:</label>
                                            <Field name="certificateNumber" style={{ ...inputStyle, width: '370px' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Recipient */}
                            <div>
                                <h3 style={sectionHeaderStyle}>Recipient</h3>
                                <div style={{ padding: '12px' }}>
                                    <div style={{ marginBottom: '12px' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Name:</label>
                                        <Field
                                            name="recipientName"
                                            as="select"
                                            style={inputStyle}
                                            onChange={(e) => {
                                                const selectedId = e.target.value;
                                                setFieldValue('recipientName', selectedId);

                                                // Find the selected recipient and auto-populate the address field
                                                const selectedRecipient = recipientOptions.find(r => r.id === selectedId);
                                                if (selectedRecipient && selectedRecipient.address) {
                                                    const addressText = `${selectedRecipient.address.street}, ${selectedRecipient.address.city}, ${selectedRecipient.address.state}, ${selectedRecipient.address.country}`;
                                                    setFieldValue('recipientAddress', addressText);
                                                    fetchQuantities(selectedId);

                                                    // Update receiptLocation for payload
                                                    setReceiptLocation({
                                                        city: selectedRecipient.address.city,
                                                        state: selectedRecipient.address.state,
                                                        country: selectedRecipient.address.country,
                                                        zipCode: selectedRecipient.address.zipCode,
                                                        lat: selectedRecipient.address.latitute,
                                                        lng: selectedRecipient.address.longitute
                                                    });
                                                } else {
                                                    // Clear the address if no recipient selected
                                                    setFieldValue('recipientAddress', '');
                                                    setReceiptLocation({});
                                                }

                                                setSelectedQuantities([]);
                                                setSelectedOrderIds([]);
                                                setFieldValue('quantity', '');
                                            }}
                                        >
                                            <option value="">Select Recipient</option>
                                            {recipientOptions.map((recipient, index) => (
                                                <option key={index} value={recipient.id || recipient._id || ''}>
                                                    {recipient.personalDetails.name || recipient.personalDetails.name}
                                                </option>
                                            ))}
                                        </Field>
                                        {loading && <div style={{ fontSize: '12px', color: '#666' }}>Loading recipients...</div>}
                                    </div>
                                    <div style={{ marginBottom: '12px' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Address:</label>
                                        <Field name="recipientAddress" as="textarea" rows={3} style={inputStyle} />
                                    </div>
                                    <div>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Contract Number:</label>
                                        <Field name="contractNumber" style={inputStyle} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Address Section */}
                        <div style={{ padding: '12px', borderTop: '1px solid #000' }}>
                            {/* 1. Dispatch Address */}
                            {/* 1. Dispatch Address */}
                            <div className='fv-row mb-3'>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                                    <label className='fs-6 mb-0' style={{ minWidth: '250px', maxWidth: '250px', fontSize: "16px" }}>
                                        Address of dispatch/shipping point of the sustainable material:
                                    </label>
                                    <div style={{ flexGrow: 1, minWidth: '400px' }}>
                                        <AutoCompleteAddress2
                                            address={dispatchAddress}
                                            setAddress={setDispatchAddress}
                                            location={dispatchLocation}
                                            formik={formik}
                                            setlocation={setDispatchLocation}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 1.1 Checkbox: Same as supplier */}
                            <div style={{ marginBottom: '16px', paddingLeft: '265px' }}>
                                <label style={{ fontSize: '12px' }}>
                                    <Field name="sameAsSupplierAddress" type="checkbox" style={{ marginRight: '6px' }} />
                                    Same as address of supplier
                                </label>
                            </div>

                            {/* 2. Receipt Address */}
                            <div className='fv-row mb-3'>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                                    <label className='fs-6 mb-0' style={{ minWidth: '250px', maxWidth: '250px', fontSize: "16px" }}>
                                        Address of receipt/receiving point of the sustainable material:
                                    </label>
                                    <div style={{ flexGrow: 1, minWidth: '400px' }}>
                                        <AutoCompleteAddress2
                                            address={receiptAddress}
                                            setAddress={setReceiptAddress}
                                            location={receiptLocation}
                                            formik={formik}
                                            setlocation={setReceiptLocation}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 2.1 Checkbox: Same as recipient */}
                            <div style={{ marginBottom: '16px', paddingLeft: '265px' }}>
                                <label style={{ fontSize: '12px' }}>
                                    <Field name="sameAsRecipientAddress" type="checkbox" style={{ marginRight: '6px' }} />
                                    Same as address of recipient
                                </label>
                            </div>
                            {/* 3. Date of Dispatch */}
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <div style={{ minWidth: '260px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>
                                        Date of dispatch  of the<br />
                                        sustainable material:
                                    </label>
                                </div>
                                <Field
                                    name="dateOfDispatch"
                                    type="date"
                                    style={{ ...inputStyle, width: '250px', marginLeft: '12px' }}
                                />
                            </div>
                        </div>


                        {/* General Information */}
                        <div style={{ borderTop: '1px solid #000' }}>
                            <h3 style={sectionHeaderStyle}>1. General information</h3>
                            <div style={{ padding: '12px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>
                                        Type of Product: (e.g. raw material, crude oil)
                                    </label>
                                    <Field
                                        as="select"
                                        name="typeOfProduct"
                                        style={inputStyle}  // Use the same inputStyle as other fields
                                        // onChange={(e) => {
                                        //     const value = e.target.value;
                                        //     setFieldValue('typeOfProduct', value);
                                        //     setSelectedProductType(value);
                                        // }}

                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFieldValue('typeOfProduct', value);

                                            // Find the selected product to get its ID
                                            const selectedProduct = productTypes.find(type => (type.name || type.name) === value);
                                            const productId = selectedProduct?.id || selectedProduct?._id || value;

                                            setSelectedProductType(productId); // Send ID instead of name
                                        }}
                                    >
                                        <option value="">Select Product Type</option>
                                        {Array.isArray(productTypes) && productTypes.map((type) => (
                                            <option key={type.id || type._id} value={type.name || type.name}>
                                                {type.name || type.title || type.categoryName}
                                            </option>
                                        ))}
                                    </Field>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>
                                        Type of Raw material Additional Information, e.g. on compliance with Add-ons etc. (voluntary):
                                    </label>
                                    <Field
                                        as="select"
                                        name="typeOfRawMaterial"
                                        style={inputStyle}  // Use the same inputStyle as other fields
                                        disabled={!selectedProductType}
                                    >
                                        <option value="">Select Raw material Type</option> name="rawMaterialType"
                                        {Array.isArray(rawMaterialTypes) && rawMaterialTypes.map((type) => (
                                            <option key={type.id || type._id} value={type.id || type._id}>
                                                {type.name || type.title || type.itemName}
                                            </option>
                                        ))}
                                    </Field>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Country of Origin (of the raw material):</label>
                                    <CountryDropDown2 name='country' formik={formik} showNameOnly />
                                </div>



                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Quantity:</label>
                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                        {/* Custom Dropdown */}
                                        <div style={{ position: 'relative', width: '300px' }} data-quantity-dropdown>
                                            {/* Dropdown trigger */}
                                            <div
                                                onClick={() => setIsQuantityDropdownOpen(!isQuantityDropdownOpen)}
                                                style={{
                                                    ...inputStyle,
                                                    width: '100%',
                                                    height: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    cursor: 'pointer',
                                                    backgroundColor: 'white'
                                                }}
                                            >
                                                <span style={{ fontSize: '12px', color: selectedQuantities.length > 0 ? '#000' : '#999' }}>
                                                    {selectedQuantities.length > 0
                                                        ? `${quantityOptions.find(opt => `${opt.orderId}-${opt.itemId}-${opt.quantity}` === selectedQuantities[0])?.categoryName || 'Selected'} - ${quantityOptions.find(opt => `${opt.orderId}-${opt.itemId}-${opt.quantity}` === selectedQuantities[0])?.itemName || ''}`
                                                        : 'Select quantity...'}
                                                </span>
                                                <span style={{ fontSize: '12px' }}>▼</span>
                                            </div>

                                            {/* Dropdown content */}
                                            {isQuantityDropdownOpen && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    right: 0,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    backgroundColor: 'white',
                                                    border: '1px solid #000',
                                                    borderTop: 'none',
                                                    zIndex: 1000
                                                }}>
                                                    {Array.isArray(quantityOptions) && quantityOptions.map((option, index) => {
                                                        const value = `${option.orderId}-${option.itemId}-${option.quantity}`;
                                                        const isSelected = selectedQuantities.includes(value);

                                                        return (
                                                            <div
                                                                key={index}
                                                                // onClick={() => {
                                                                //     const selectedId = option.orderId || '';

                                                                //     // Single select logic - clear previous selections
                                                                //     setSelectedQuantities([value]);
                                                                //     setSelectedOrderIds([selectedId]);

                                                                //     // Calculate quantity for single item
                                                                //     setFieldValue('quantity', (option.quantity || 0).toString());

                                                                //     // Close dropdown after selection
                                                                //     setIsQuantityDropdownOpen(false);

                                                                //     // If "No" is selected for total default value, fetch order details
                                                                //     if (isNoSelected && selectedId) {
                                                                //         fetchOrderDetails(selectedId, setFieldValue);
                                                                //     }
                                                                // }}
                                                                // In the quantity dropdown onClick handler:
                                                                onClick={() => {
                                                                    const selectedId = option.orderId || '';

                                                                    // Single select logic - clear previous selections
                                                                    setSelectedQuantities([value]);
                                                                    setSelectedOrderIds([selectedId]); // This already stores the orderId

                                                                    // Calculate quantity for single item
                                                                    setFieldValue('quantity', (option.quantity || 0).toString());

                                                                    // Close dropdown after selection
                                                                    setIsQuantityDropdownOpen(false);

                                                                    // If "No" is selected for total default value, fetch order details
                                                                    if (isNoSelected && selectedId) {
                                                                        fetchOrderDetails(selectedId, setFieldValue);
                                                                    }
                                                                }}
                                                                style={{
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: isSelected ? '#f0f8ff' : 'white',
                                                                    borderBottom: '1px solid #eee',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    fontSize: '12px'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    if (!isSelected) {
                                                                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (!isSelected) {
                                                                        e.currentTarget.style.backgroundColor = 'white';
                                                                    }
                                                                }}
                                                            >
                                                                {/* Removed checkbox for single select */}
                                                                <span>{`${option.categoryName} - ${option.itemName} - ${option.quantity}`}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>

                                        {/* Radio buttons for units */}
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name="quantityUnit" type="radio" value="metric tons" style={{ marginRight: '4px' }} />
                                                metric tons
                                            </label>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name="quantityUnit" type="radio" value="m³" style={{ marginRight: '4px' }} />
                                                m³
                                            </label>
                                        </div>
                                    </div>
                                </div>





                                <div style={{ marginBottom: '12px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '8px' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>ISCC Compliant material¹:</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name="isccCompliant" type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                                Yes
                                            </label>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name="isccCompliant" type="radio" value="No" style={{ marginRight: '4px' }} />
                                                No
                                            </label>
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>EU RED Compliant material²:</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name="euRedCompliant" type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                                Yes
                                            </label>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name="euRedCompliant" type="radio" value="No" style={{ marginRight: '4px' }} />
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Chain of custody option (voluntary):</label>
                                    <Field name="chainOfCustody" as="select" style={{ ...inputStyle, width: '300px' }}>
                                        <option value="Please select">Please select</option>
                                        <option value="Segregation">Segregation</option>
                                        <option value="Mass balance">Mass balance</option>
                                    </Field>
                                </div>
                            </div>
                        </div>

                        {/* Scope of certification */}
                        <div style={{ borderTop: '1px solid #000' }}>
                            <h3 style={sectionHeaderStyle}>2. Scope of certification of raw material</h3>
                            <div style={{ padding: '12px' }}>
                                {[
                                    { name: 'rawMaterialComplies', label: 'The raw material complies with the relevant sustainability criteria according to Art. 29 (2) - (7) RED III³' },
                                    { name: 'agriculturalBiomass', label: 'The agricultural biomass was cultivated as intermediate crop (if applicable)' },
                                    { name: 'agriculturalBiomassLowILUC', label: 'The agricultural biomass additionally fulfills the measures for low ILUC risk feedstocks (if applicable)' },
                                    { name: 'wasteOrResidue', label: 'The raw material meets the definition of waste or residue according to the RED III⁴' },
                                    { name: 'fuelProductionSupport', label: 'Was support for the production of the fuel or fuel precursor received?⁵' },
                                ].map((item, index) => (
                                    <div key={index} style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', flex: 1, marginBottom: 0 }}>{item.label}</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name={item.name} type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                                Yes
                                            </label>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name={item.name} type="radio" value="No" style={{ marginRight: '4px' }} />
                                                No
                                            </label>
                                        </div>
                                    </div>
                                ))}

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>If applicable, please specify waste or animal by-product permit number:</label>
                                    <Field name="wasteSpecification" style={{ ...inputStyle, width: '100%' }} />
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>If applicable, please specify support nature and scheme:</label>
                                    <Field name="supportSpecification" style={{ ...inputStyle, width: '100%' }} />
                                </div>
                            </div>
                        </div>

                        {/* GHG Emission Information */}
                        <div style={{ borderTop: '1px solid #000' }}>
                            <h3 style={sectionHeaderStyle}>3. Greenhouse Gas (GHG) emission information</h3>
                            <div style={{ padding: '12px' }}>
                                {/* <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', flex: 1, marginBottom: 0 }}>Total default value according to RED III applied:</label>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <label style={{ fontSize: '12px' }}>
                                            <Field name="totalDefaultValue" type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                            Yes
                                        </label>
                                        <label style={{ fontSize: '12px' }}>
                                            <Field name="totalDefaultValue" type="radio" value="No" style={{ marginRight: '4px' }} />
                                            No
                                        </label>
                                    </div>
                                </div> */}



                                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', flex: 1, marginBottom: 0 }}>Total default value according to RED III applied:</label>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <label style={{ fontSize: '12px' }}>
                                            <Field
                                                name="totalDefaultValue"
                                                type="radio"
                                                value="Yes"  // ✅ Fix: Change to "Yes"
                                                style={{ marginRight: '4px' }}
                                                onChange={() => {
                                                    setFieldValue('totalDefaultValue', 'Yes'); // ✅ Fix: Change to 'Yes'
                                                    setIsNoSelected(false); // ✅ Fix: Change to false
                                                }}
                                            />
                                            Yes
                                        </label>
                                        <label style={{ fontSize: '12px' }}>
                                            <Field
                                                name="totalDefaultValue"
                                                type="radio"
                                                value="No"  // ✅ This is correct
                                                style={{ marginRight: '4px' }}
                                                onChange={() => {
                                                    setFieldValue('totalDefaultValue', 'No');
                                                    setIsNoSelected(true);
                                                    // Call API for selected order IDs
                                                    if (selectedOrderIds.length > 0) {
                                                        selectedOrderIds.forEach(orderId => {
                                                            fetchOrderDetails(orderId, setFieldValue);
                                                        });
                                                    }
                                                }}
                                            />
                                            No
                                        </label>
                                    </div>
                                </div>

                                <div style={{ fontSize: '12px', marginBottom: '12px' }}>
                                    Please fill out only the relevant calculation formula elements.<br />
                                    If Disaggregated Default Value is applied, please state "DDV" in the respective calculation formula element.<br />
                                    If actual or NUTS2 value is applied, please state the GHG emission value in kgCO2eq/dry-ton
                                </div>

                                <div style={{ display: 'flex', alignItems: 'end', gap: '4px', marginBottom: '12px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '4px' }}>
                                        {['Eec', 'El', 'Ep', 'Etd', 'Eu', 'Esca', 'Eccs', 'Eccr'].map((field) => (
                                            <div key={field}>
                                                <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', textAlign: 'center', display: 'block' }}>{field}</label>
                                                <Field name={field.toLowerCase()} style={{ ...inputStyle, width: '60px' }} />
                                            </div>
                                        ))}
                                    </div>
                                    <div style={{ fontSize: '12px', marginLeft: '8px', marginBottom: '6px' }}>kgCO2eq/dry-ton</div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Means of transport <br />
                                        Transport distance in km
                                    </label>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                                        <div>
                                            <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Ship</label>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Field name="shipKm" style={{ ...inputStyle, width: '80px' }} />
                                                <span style={{ marginLeft: '4px', fontSize: '12px' }}>km</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Train</label>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Field name="trainKm" style={{ ...inputStyle, width: '80px' }} />
                                                <span style={{ marginLeft: '4px', fontSize: '12px' }}>km</span>
                                            </div>
                                        </div>
                                        <div>
                                            <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Road</label>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Field name="roadKm" style={{ ...inputStyle, width: '80px' }} />
                                                <span style={{ marginLeft: '4px', fontSize: '12px' }}>km</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ fontSize: '10px', fontStyle: 'italic', marginBottom: '12px' }}>
                                    Only relevant if the recipient of the material is responsible to calculate actual emissions from transport and for biomass fuels
                                </div>

                                {[
                                    { name: 'oilExtractionDefault', label: 'Disaggregated default value for oil extraction only is applied' },
                                    { name: 'soilN2ODefault', label: 'Disaggregated default value for soil N₂O emissions is applied' },
                                ].map((item, index) => (
                                    <div key={index} style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', flex: 1, marginBottom: 0 }}>{item.label}</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name={item.name} type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                                Yes
                                            </label>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name={item.name} type="radio" value="No" style={{ marginRight: '4px' }} />
                                                No
                                            </label>
                                        </div>
                                    </div>
                                ))}

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>Esca: Specify which Bonus or Cap applies to any claimed Esca savings:</label>
                                    <Field name="escaSpecification" style={{ ...inputStyle, width: '100%' }} />
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: '12px', alignItems: 'start', marginBottom: '12px' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4' }}>If applicable, please specify the NUTS2 area:</label>
                                    <Field name="nuts2Area" style={{ ...inputStyle, width: '100%' }} />
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', flex: 1, marginBottom: 0 }}>
                                        El: Bonus of 29 g CO2eq/MJ biofuel/bioliquid/biomass fuel if biomass is obtained from restored degraded land
                                    </label>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <label style={{ fontSize: '12px' }}>
                                            <Field name="degradedLandBonus" type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                            Yes
                                        </label>
                                        <label style={{ fontSize: '12px' }}>
                                            <Field name="degradedLandBonus" type="radio" value="No" style={{ marginRight: '4px' }} />
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Voluntary Add-Ons */}
                        <div style={{ borderTop: '1px solid #000' }}>
                            <h3 style={sectionHeaderStyle}>4. Voluntary Add-Ons</h3>
                            <div style={{ padding: '12px' }}>
                                {[
                                    { name: 'foodSecurityStandard', label: 'Food Security Standard (FSS) - 202-04' },
                                    { name: 'euDeforestationRegulation', label: 'EU Deforestration Regulation (EUDR) - 202-09' },
                                    { name: 'nonGMOFood', label: 'Non-GMO for Food and Feed - 205-03' },
                                    { name: 'nonGMOTechnical', label: 'Non-GMO for Technical Markets - 205-04' },
                                ].map((item, index) => (
                                    <div key={index} style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <label style={{ ...labelStyle, fontSize: '14px', lineHeight: '1.4', flex: 1, marginBottom: 0 }}>{item.label}</label>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name={item.name} type="radio" value="Yes" style={{ marginRight: '4px' }} />
                                                Yes
                                            </label>
                                            <label style={{ fontSize: '12px' }}>
                                                <Field name={item.name} type="radio" value="No" style={{ marginRight: '4px' }} />
                                                No
                                            </label>
                                        </div>
                                    </div>
                                ))}
                                <div style={{
                                    marginTop: '16px',
                                    padding: '8px',
                                    backgroundColor: '#fff',
                                    border: '1px solid #000',
                                    textAlign: 'center',
                                    color: 'red',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    Not valid without Certificate Number of the ISCC certificate above
                                </div>
                            </div>
                        </div>

                        {/* Submit Buttons */}
                        <div style={{
                            padding: '20px',
                            borderTop: '1px solid #000',
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'flex-end',
                            backgroundColor: '#f5f5f5'
                        }}>
                            <button
                                type="button"
                                onClick={onClose}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={async () => {
                                    console.log('Submit button clicked!');

                                    // Get franchise ID
                                    const authData = localStorage.getItem('kt-auth-react-v');
                                    let franchiseId = '';
                                    if (authData) {
                                        const parsedData = JSON.parse(authData);
                                        franchiseId = parsedData?.data?.franchiseeid || '';
                                    }




                                    const dateOfIssuance = (document.querySelector('[name="dateOfIssuance"]') as HTMLInputElement)?.value || '';
                                    const dateOfDispatch = (document.querySelector('[name="dateOfDispatch"]') as HTMLInputElement)?.value || '';

                                    // Convert dates to string timestamps
                                    const dateOfIssuanceTimestamp = dateOfIssuance ? new Date(dateOfIssuance).getTime().toString() : '';
                                    const dateOfDispatchTimestamp = dateOfDispatch ? new Date(dateOfDispatch).getTime().toString() : '';

                                    // Get selected recipient info
                                    const selectedRecipientId = (document.querySelector('[name="recipientName"]') as HTMLSelectElement)?.value || '';
                                    const selectedRecipient = recipientOptions.find(r => (r.id || r._id) === selectedRecipientId);
                                    const selectedRecipientName = selectedRecipient?.personalDetails?.name || '';
                                    const supplierId = authData ? JSON.parse(authData)?.data?.userId || "" : "";

                                    // Get form values with proper TypeScript typing
                                    const uniqueNumber = (document.querySelector('[name="uniqueNumber"]') as HTMLInputElement)?.value || '';
                                    // const dateOfIssuance = (document.querySelector('[name="dateOfIssuance"]') as HTMLInputElement)?.value || '';
                                    const supplierName = (document.querySelector('[name="supplierName"]') as HTMLInputElement)?.value || '';
                                    const supplierAddress = (document.querySelector('[name="supplierAddress"]') as HTMLTextAreaElement)?.value || '';
                                    const recipientAddress = (document.querySelector('[name="recipientAddress"]') as HTMLTextAreaElement)?.value || '';
                                    const certificateNumber = (document.querySelector('[name="certificateNumber"]') as HTMLInputElement)?.value || '';
                                    const contractNumber = (document.querySelector('[name="contractNumber"]') as HTMLInputElement)?.value || '';
                                    const countryOfOrigin = (document.querySelector('[name="country"]') as HTMLSelectElement)?.value || '';
                                    const quantity = (document.querySelector('[name="quantity"]') as HTMLInputElement)?.value || '';
                                    // const dateOfDispatch = (document.querySelector('[name="dateOfDispatch"]') as HTMLInputElement)?.value || '';
                                    const typeOfProduct = (document.querySelector('[name="typeOfProduct"]') as HTMLSelectElement)?.value || '';
                                    const chainOfCustody = (document.querySelector('[name="chainOfCustody"]') as HTMLSelectElement)?.value || '';

                                    // Get radio button values
                                    const quantityUnit = (document.querySelector('[name="quantityUnit"]:checked') as HTMLInputElement)?.value || 'metric tons';
                                    const isccCompliant = (document.querySelector('[name="isccCompliant"]:checked') as HTMLInputElement)?.value || '';
                                    const euRedCompliant = (document.querySelector('[name="euRedCompliant"]:checked') as HTMLInputElement)?.value || '';

                                    console.log('Form values collected:', {
                                        uniqueNumber,
                                        dateOfIssuance,
                                        supplierName,
                                        selectedRecipientName,
                                        quantity,
                                        typeOfProduct
                                    });

                                    setSubmitLoading(true);

                                    try {
                                        const payload = {
                                            quantity: Number(values.quantity) || 0,
                                            orderId: selectedOrderIds.length > 0 ? selectedOrderIds[0] : '',
                                            orderIds: selectedOrderIds,
                                            franchiseId: franchiseId,
                                            uniqueNo: uniqueNumber,
                                            date: dateOfIssuanceTimestamp,
                                            supplierInfo: {
                                                id: supplierId,
                                                name: supplierName,
                                                address: {
                                                    city: dispatchLocation?.city || "",
                                                    state: dispatchLocation?.state || "",
                                                    country: dispatchLocation?.country || "",
                                                    zipCode: dispatchLocation?.zipCode || "",
                                                    street: supplierAddress,
                                                    latitute: dispatchLocation?.lat || 0,
                                                    longitute: dispatchLocation?.lng || 0
                                                }
                                            },
                                            recipientInfo: {
                                                id: selectedRecipientId,
                                                name: selectedRecipientName,
                                                address: {
                                                    city: receiptLocation?.city || "",
                                                    state: receiptLocation?.state || "",
                                                    country: receiptLocation?.country || "",
                                                    zipCode: receiptLocation?.zipCode || "",
                                                    street: recipientAddress, // This comes from the textarea field
                                                    latitute: receiptLocation?.lat || 0,
                                                    longitute: receiptLocation?.lng || 0
                                                }
                                            },
                                            certificateNo: certificateNumber,
                                            contactNo: contractNumber,
                                            addressOfShippingPoint: {
                                                city: dispatchLocation?.city || "",
                                                state: dispatchLocation?.state || "",
                                                country: dispatchLocation?.country || "",
                                                zipCode: dispatchLocation?.zipCode || "",
                                                street: dispatchAddress,
                                                latitute: dispatchLocation?.lat || 0,
                                                longitute: dispatchLocation?.lng || 0
                                            },
                                            addressOfReceivingPoint: {
                                                city: receiptLocation?.city || "",
                                                state: receiptLocation?.state || "",
                                                country: receiptLocation?.country || "",
                                                zipCode: receiptLocation?.zipCode || "",
                                                street: receiptAddress,
                                                latitute: receiptLocation?.lat || 0,
                                                longitute: receiptLocation?.lng || 0
                                            },
                                            dateOfDispatch: dateOfDispatchTimestamp,
                                            productName: typeOfProduct,
                                            countryOfOrigin: countryOfOrigin,
                                            // quantity: Number(quantity) || 0,
                                            unit: quantityUnit === 'metric tons' ? 'METRIC_TONS' : quantityUnit === 'm³' ? 'M3' : 'KG',
                                            isISCCCompliant: isccCompliant === 'Yes',
                                            isEUREDCompliant: euRedCompliant === 'Yes',
                                            chainOfCustody: chainOfCustody,
                                            SCOPE: {
                                                REDIII: (document.querySelector('[name="rawMaterialComplies"]:checked') as HTMLInputElement)?.value === 'Yes' || false,
                                                INTERMEDIATE_CROP: (document.querySelector('[name="agriculturalBiomass"]:checked') as HTMLInputElement)?.value === 'Yes' || false,
                                                ILUC: (document.querySelector('[name="agriculturalBiomassLowILUC"]:checked') as HTMLInputElement)?.value === 'Yes' || false,
                                                WASTE: (document.querySelector('[name="wasteOrResidue"]:checked') as HTMLInputElement)?.value === 'Yes' || false,
                                                PRODUCTION_SUPPORT: (document.querySelector('[name="fuelProductionSupport"]:checked') as HTMLInputElement)?.value === 'Yes' || false,
                                                WASTE_PERMIT_NUMBER: (document.querySelector('[name="wasteSpecification"]') as HTMLInputElement)?.value || '',
                                                SUPPORT_SCHEME: (document.querySelector('[name="supportSpecification"]') as HTMLInputElement)?.value || ''
                                            }
                                        };

                                        console.log('Payload:', payload);

                                        const response = await axios.post(
                                            `${process.env.REACT_APP_BASE_API_URL}isccSustainability/create`,
                                            payload,
                                            {
                                                headers: {
                                                    ...getAuthHeaders(),
                                                    'Accept': 'application/json'
                                                }
                                            }
                                        );

                                        console.log('Form submitted successfully:', response.data);
                                        successToast('Sustainability Declaration submitted successfully!');
                                        window.location.reload();
                                        onClose();
                                    } catch (error) {
                                        console.error('Error submitting form:', error);
                                        alert('Error submitting form. Please try again.');
                                    } finally {
                                        setSubmitLoading(false);
                                    }
                                }}
                                disabled={submitLoading}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: submitLoading ? '#ccc' : '#005faf',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: submitLoading ? 'not-allowed' : 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                {submitLoading ? 'Submitting...' : 'Submit Declaration'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default SustainabilityDeclarationForm